<template>
    <div>
        <h1>API Test</h1>

        <div class="row">
            <div class="col-6">
                <form @submit.prevent="submitForm">
                    <label for="num_results">Num results:</label>
                    <input type="text" id="num_results" v-model="num_results" required>

                    <label for="temperature">Temperature:</label>
                    <input type="text" id="temperature" v-model="temperature" required>

                    <label for="top_p">Top P:</label>
                    <input type="text" id="top_p" v-model="topP" required>

                    <label for="engine">Engine:</label>
                    <select id="engine" v-model="engine" required>
                        <option value="text-davinci-003">text-davinci-003</option>
                        <option value="text-curie-001">text-curie-001</option>
                        <option value="text-babbage-001">text-babbage-001</option>
                        <option value="text-ada-001">text-ada-001</option>
                        <option value="gpt-3.5-turbo">gpt-3.5-turbo</option>
                    </select>

                    <label for="prompt">Prompt:</label>
                    <textarea id="prompt" v-model="prompt" rows="20" cols="100" style="width: 100%;" required></textarea>

                    <button type="submit">Submit</button>
                </form>
            </div>

            <div class="col-6">
                <div v-if="results.length > 0">
                    <h2>Results:</h2>
                    <ul>
                        <li v-for="(result, index) in results" :key="index">{{ result }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies';

export default {
    data() {
        return {
            temperature: null,
            topP: null,
            engine: null,
            prompt: null,
            results: [],
            num_results: 3
        };
    },
    mounted() {
        // Load saved values from cookies
        this.temperature = VueCookies.get('temperature') || null;
        this.topP = VueCookies.get('topP') || null;
        this.engine = VueCookies.get('engine') || null;
        this.prompt = VueCookies.get('prompt') || null;
        this.num_results = VueCookies.get('num_results') || null;
    },
    watch: {
        // Save field values in cookies whenever they change
        temperature(newValue) {
            VueCookies.set('temperature', newValue);
        },
        topP(newValue) {
            VueCookies.set('topP', newValue);
        },
        engine(newValue) {
            VueCookies.set('engine', newValue);
        },
        prompt(newValue) {
            VueCookies.set('prompt', newValue);
        },
        num_results(newValue) {
            VueCookies.set('num_results', newValue);
        }
    },
    methods: {
        async submitForm() {
            this.results = []; // Clear previous results

            const requestData = {
                temperature: this.temperature,
                top_p: this.topP,
                engine: this.engine,
                prompt: this.prompt
            };

            for (let i = 0; i < this.num_results; i++) {
                try {
                    const response = await this.$http.post('/test_prompt', requestData);
                    console.log(response)
                    const result = response.data.proposal;
                    this.results.push(result);
                } catch (error) {
                    console.error(error);
                }
            }
        }
    }
};
</script>
